// rotator.js
var Rotator = pc.createScript('rotator');

// initialize code called once per entity
Rotator.prototype.initialize = function() {

};

// update code called every frame
Rotator.prototype.update = function(dt) {
    this.entity.rotate(0,0.5,0);
};

// swap method called for script hot-reloading
// inherit your script state here
// Rotator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

